
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PrinterListLoadBody extends Vue {
  @Prop(Function) public close: () => void;
}
